import React, { useState } from 'react'
import PropTypes from 'prop-types'

// components
import { Button, Text, If, CloseButton } from '../../../../components'
import { ExclamationTriangle } from '../../../../components/Svg'

// styles
import styles from './CatchAllError.module.scss'

const CatchAllError = ({ onClose, error }) => {
  const [loading, setLoading] = useState(false)
  const [showErrorMessage, setShowErrorMessage] = useState(false)

  const handleRetryClick = () => {
    setLoading(true)
    window.location.reload()
    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }

  const handleShowErrorMessage = () => {
    setShowErrorMessage(!showErrorMessage)
  }

  const renderStackTrace = e => {
    const error = new Error(e)

    return error.stack
  }

  return (
    <div className={styles.root}>
      <CloseButton className={styles.close} onClick={onClose} />
      <div className={styles.CatchAllError}>
        <ExclamationTriangle className={styles.triangle} />
        <Text color='white' weight='bold' size='l'>
          Something unexpected happened
        </Text>
        <Text color='heather'>
          Because you encountered something we hadn't considered, we hope
          reloading will fix it
        </Text>
        <Button
          regular
          wide
          className={styles.retryButton}
          loading={loading}
          onClick={handleRetryClick}
        >
          Reload Page
        </Button>
        <Button minimal onClick={handleShowErrorMessage}>
          {showErrorMessage && 'Hide Error Details'}
          {!showErrorMessage && 'Show Error Details'}
        </Button>
        <If condition={showErrorMessage}>
          <div className={styles.errorMessage}>
            <Text
              align='left'
              color='white'
              size='xs'
              className={styles.errorText}
            >
              {renderStackTrace(error)}
            </Text>
          </div>
        </If>
        <hr />
        <Text color='heather' className={styles.reachOut}>
          If the problem continues,
        </Text>
        <Text color='heather'>
          reach out to
          <a href={'mailto:support@homebot.ai'} className={styles.link}>
            {' '}
            support@homebot.ai
          </a>
        </Text>
      </div>
    </div>
  )
}

CatchAllError.propTypes = {
  onClose: PropTypes.func.isRequired,
  error: PropTypes.string,
}

CatchAllError.defaultProps = {
  error: null,
}

export default CatchAllError
